import type { AxiosInstance } from 'axios';
import { errorLogger, requestLogger, responseLogger } from 'axios-logger';
import type { RequestLogConfig, ResponseLogConfig } from 'axios-logger/lib/common/types';

import { isBrowser } from '@/Module/Core/Helper';

const errorConfig: RequestLogConfig = {
  prefixText: 'ServiceError',
};

const requestConfig: RequestLogConfig = {
  prefixText: 'ServiceRequest',
};

const responseConfig: ResponseLogConfig = {
  prefixText: 'ServiceResponse',
  status: true,
  logger: text => {
    /* eslint-disable no-console */
    return console.log(text?.slice(0, 200));
    /* eslint-enable no-console */
  },
};

export const httpServiceLoggerInit = (instance: AxiosInstance) => {
  instance.interceptors.request.use(
    // @ts-ignore
    request => {
      if (isBrowser()) return request;
      return requestLogger(request, {
        ...requestConfig,
        data: true,
        params: true,
      });
    },
    error => {
      if (isBrowser()) return Promise.reject(error);
      return errorLogger(error, errorConfig);
    },
  );

  instance.interceptors.response.use(
    request => {
      if (isBrowser()) return request;
      return responseLogger(request, responseConfig);
    },
    error => {
      if (isBrowser()) return Promise.reject(error);
      return errorLogger(error, {
        ...errorConfig,
        statusText: true,
      });
    },
  );
};
